import type { ReactElement } from 'react';
import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function Wrench(props: IconSvgProps): ReactElement {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M20.3326 6.87896C20.8041 7.97981 20.9195 9.20053 20.6627 10.3702C20.4059 11.5399 19.7898 12.6 18.9005 13.4022C18.0113 14.2043 16.8934 14.7082 15.7035 14.8434C14.5136 14.9787 13.3112 14.7384 12.2647 14.1563V14.1563L7.22444 19.9962C6.81937 20.4012 6.26996 20.6288 5.6971 20.6288C5.12423 20.6288 4.57483 20.4012 4.16976 19.9962C3.76468 19.5911 3.53711 19.0417 3.53711 18.4688C3.53711 17.8959 3.76468 17.3465 4.16976 16.9415L10.0096 11.9012C9.42749 10.8547 9.18724 9.65226 9.32247 8.46236C9.4577 7.27247 9.96164 6.15464 10.7638 5.26539C11.5659 4.37614 12.626 3.75998 13.7957 3.50318C14.9654 3.24638 16.1861 3.36179 17.2869 3.83326L13.5135 7.59771L14.0256 10.1403L16.5682 10.6524L20.3326 6.87896Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </BaseLibraryIconSvg>
  );
}
